/**
 * The shippingType note_attribute in the Shopify Order
 */
export enum ShippingType {
    HD = 'hd',
    MPL_HA = 'mpl_ha',
    MPL_CS = 'mpl_cs',
    MPL_DELIVERY = 'mpl',
    MPL_MOL = 'mpl_mol',
    MPL_MEDIAMARKT = 'mpl_mediamarkt',
    MPL_COOP = 'mpl_coop',
    MPL_OFFICE = 'mpl_office',
    MPL_OTHER = 'mpl_other',
    FOXPOST = 'foxpost',
    GLS = 'gls',
    GLS_CS = 'gls_cs',
    GLS_HD = 'gls_hd',
    GLSGLOB_HD = 'glsglob_hd',
    GLSGLOB_KEEPER = 'glsglob_keeper',
    GLSGLOB_LOCKER = 'glsglob_locker',
    GLSGLOB_SHOP = 'glsglob_shop',
    GLSGLOB_SHOP_IN_SHOP = 'glsglob_shop_in_shop',
    PACKETA = 'packeta',
    PACKETA_BOX = 'packeta_box',
    PACKETA_BRANCH = 'packeta_branch',
    FOXPOST_HD = 'foxpost_hd',
    FOXPOST_APM = 'foxpost_apm',
    FOXPOST_PACKETA_PP = 'foxpost_packeta_pp',
    FOXPOST_PACKETA_APM = 'foxpost_packeta_apm',
    DPD = 'dpd',
    DPD_PP = 'dpd_pp',
    DPD_HD = 'dpd_hd',
    SPRINTER = 'sprinter',
    FANCOURIER_OFFICE = 'fancourier_office',
    FANCOURIER_FANBOX = 'fancourier_fanbox',
    FANCOURIER_PAYPOINT = 'fancourier_paypoint',
    FANCOURIER_HD = 'fancourier_hd',
    FCI_PUDO_CZP = 'fci_pudo_czp',
    FCI_PUDO_FAN = 'fci_pudo_fan',
    FCI_PUDO_GLS = 'fci_pudo_gls',
    FCI_PUDO_HRP = 'fci_pudo_hrp',
    FCI_PUDO_INP = 'fci_pudo_inp',
    FCI_PUDO_LTP = 'fci_pudo_ltp',
    FCI_PUDO_MULTI = 'fci_pudo_multi',
    FCI_PUDO_PSL = 'fci_pudo_psl',
    FCI_PUDO_SLK = 'fci_pudo_slk',
    FCI_LOCKER_CZP = 'fci_locker_czp',
    FCI_LOCKER_FAN = 'fci_locker_fan',
    FCI_LOCKER_GLS = 'fci_locker_gls',
    FCI_LOCKER_HRP = 'fci_locker_hrp',
    FCI_LOCKER_INP = 'fci_locker_inp',
    FCI_LOCKER_LTP = 'fci_locker_ltp',
    FCI_LOCKER_MULTI = 'fci_locker_multi',
    FCI_LOCKER_PSL = 'fci_locker_psl',
    FCI_LOCKER_SLK = 'fci_locker_slk',
    FCI_OFFICE_CZP = 'fci_office_czp',
    FCI_OFFICE_FAN = 'fci_office_fan',
    FCI_OFFICE_GLS = 'fci_office_gls',
    FCI_OFFICE_HRP = 'fci_office_hrp',
    FCI_OFFICE_INP = 'fci_office_inp',
    FCI_OFFICE_LTP = 'fci_office_ltp',
    FCI_OFFICE_MULTI = 'fci_office_multi',
    FCI_OFFICE_PSL = 'fci_office_psl',
    FCI_OFFICE_SLK = 'fci_office_slk',

    // GLS / DPD country providers' pickup point types: `<provider>_{locker,parcel_shop}`
    DPD_GREECE_LOCKER = 'dpd_greece_locker',
    DPD_GREECE_PARCEL_SHOP = 'dpd_greece_parcel_shop',
    DPD_ITALY_LOCKER = 'dpd_italy_locker',
    DPD_ITALY_PARCEL_SHOP = 'dpd_italy_parcel_shop',
    DPD_SLOVENIA_LOCKER = 'dpd_slovenia_locker',
    DPD_SLOVENIA_PARCEL_SHOP = 'dpd_slovenia_parcel_shop',
    DPD_GB_LOCKER = 'dpd_gb_locker',
    DPD_GB_PARCEL_SHOP = 'dpd_gb_parcel_shop',
    DPD_LATVIA_LOCKER = 'dpd_latvia_locker',
    DPD_LATVIA_PARCEL_SHOP = 'dpd_latvia_parcel_shop',
    DPD_PORTUGAL_LOCKER = 'dpd_portugal_locker',
    DPD_PORTUGAL_PARCEL_SHOP = 'dpd_portugal_parcel_shop',
    DPD_SLOVAKIA_LOCKER = 'dpd_slovakia_locker',
    DPD_SLOVAKIA_PARCEL_SHOP = 'dpd_slovakia_parcel_shop',
    DPD_BULGARIA_LOCKER = 'dpd_bulgaria_locker',
    DPD_BULGARIA_PARCEL_SHOP = 'dpd_bulgaria_parcel_shop',
    DPD_SWEDEN_LOCKER = 'dpd_sweden_locker',
    DPD_SWEDEN_PARCEL_SHOP = 'dpd_sweden_parcel_shop',
    DPD_GERMANY_LOCKER = 'dpd_germany_locker',
    DPD_GERMANY_PARCEL_SHOP = 'dpd_germany_parcel_shop',
    DPD_CZECH_REPUBLIC_LOCKER = 'dpd_czech_republic_locker',
    DPD_CZECH_REPUBLIC_PARCEL_SHOP = 'dpd_czech_republic_parcel_shop',
    DPD_LUXEMBOURG_LOCKER = 'dpd_luxembourg_locker',
    DPD_LUXEMBOURG_PARCEL_SHOP = 'dpd_luxembourg_parcel_shop',
    DPD_SPAIN_LOCKER = 'dpd_spain_locker',
    DPD_SPAIN_PARCEL_SHOP = 'dpd_spain_parcel_shop',
    DPD_SWITZERLAND_LOCKER = 'dpd_switzerland_locker',
    DPD_SWITZERLAND_PARCEL_SHOP = 'dpd_switzerland_parcel_shop',
    DPD_AUSTRIA_LOCKER = 'dpd_austria_locker',
    DPD_AUSTRIA_PARCEL_SHOP = 'dpd_austria_parcel_shop',
    DPD_BELGIUM_LOCKER = 'dpd_belgium_locker',
    DPD_BELGIUM_PARCEL_SHOP = 'dpd_belgium_parcel_shop',
    DPD_NETHERLANDS_LOCKER = 'dpd_netherlands_locker',
    DPD_NETHERLANDS_PARCEL_SHOP = 'dpd_netherlands_parcel_shop',
    DPD_ROMANIA_LOCKER = 'dpd_romania_locker',
    DPD_ROMANIA_PARCEL_SHOP = 'dpd_romania_parcel_shop',
    DPD_ESTONIA_LOCKER = 'dpd_estonia_locker',
    DPD_ESTONIA_PARCEL_SHOP = 'dpd_estonia_parcel_shop',
    DPD_FRANCE_LOCKER = 'dpd_france_locker',
    DPD_FRANCE_PARCEL_SHOP = 'dpd_france_parcel_shop',
    DPD_LITHUANIA_LOCKER = 'dpd_lithuania_locker',
    DPD_LITHUANIA_PARCEL_SHOP = 'dpd_lithuania_parcel_shop',
    GLS_FI_LOCKER = 'gls_fi_locker',
    GLS_FI_PARCEL_SHOP = 'gls_fi_parcel_shop',
    GLS_IT_LOCKER = 'gls_it_locker',
    GLS_IT_PARCEL_SHOP = 'gls_it_parcel_shop',
    GLS_BG_LOCKER = 'gls_bg_locker',
    GLS_BG_PARCEL_SHOP = 'gls_bg_parcel_shop',
    GLS_BE_LOCKER = 'gls_be_locker',
    GLS_BE_PARCEL_SHOP = 'gls_be_parcel_shop',
    GLS_FR_LOCKER = 'gls_fr_locker',
    GLS_FR_PARCEL_SHOP = 'gls_fr_parcel_shop',
    GLS_NL_LOCKER = 'gls_nl_locker',
    GLS_NL_PARCEL_SHOP = 'gls_nl_parcel_shop',
    GLS_LU_LOCKER = 'gls_lu_locker',
    GLS_LU_PARCEL_SHOP = 'gls_lu_parcel_shop',
    GLS_DE_LOCKER = 'gls_de_locker',
    GLS_DE_PARCEL_SHOP = 'gls_de_parcel_shop',
    GLS_ES_LOCKER = 'gls_es_locker',
    GLS_ES_PARCEL_SHOP = 'gls_es_parcel_shop',
    GLS_PT_LOCKER = 'gls_pt_locker',
    GLS_PT_PARCEL_SHOP = 'gls_pt_parcel_shop',
    GLS_AT_LOCKER = 'gls_at_locker',
    GLS_AT_PARCEL_SHOP = 'gls_at_parcel_shop',
    GLS_GR_LOCKER = 'gls_gr_locker',
    GLS_GR_PARCEL_SHOP = 'gls_gr_parcel_shop',
    GLS_DK_LOCKER = 'gls_dk_locker',
    GLS_DK_PARCEL_SHOP = 'gls_dk_parcel_shop',

    SAMEDAY_HD = 'sameday_hd',
    SAMEDAY_OOH = 'sameday_ooh',
    SAMEDAY_LOCKER = 'sameday_locker',
    POSTASK_LOCKER = 'postask_locker',
    POSTASK_OFFICE = 'postask_office',
    INPOST_POP = 'inpost_pop',
    INPOST_PARCEL_LOCKER = 'inpost_parcel_locker',
    INPOST_HD = 'inpost_hd',
    POSTNORD_BOX = 'postnord_box',
    POSTNORD_STAMP = 'postnord_stamp',
    POSTNORD_AGENT = 'postnord_agent',
    BRING_MANNED = 'bring_manned',
    BRING_UNMANNED = 'bring_unmanned',
    BRING_LOCKER = 'bring_locker',
    BPOST_POST_POINT = 'bpost_post_point',
    BPOST_LOCKER = 'bpost_locker',
    BPOST_POST_OFFICE = 'bpost_post_office',
    CORREOS_HOMEPAQ = 'correos_homepaq',
    OMNIVA_POST_OFFICE = 'omniva_post_office',
    OMNIVA_LOCKER = 'omniva_locker',

    CARGUS_SHOP = 'cargus_shop',
    CARGUS_LOCKER = 'cargus_locker',
    CARGUS_HD = 'cargus_hd',

    ONE_BY_ALLEGRO_PUDO = 'one_by_allegro_pudo',
    ONE_BY_ALLEGRO_BOX = 'one_by_allegro_box',
    POCZTA_POLSKA_PP = 'poczta_polska_pp',
    POCZTA_POLSKA_APM = 'poczta_polska_apm',
    ORLEN_PACZKA_APM = 'orlen_paczka_apm',
    ORLEN_PACZKA_PPP = 'orlen_paczka_ppp',
    ORLEN_PACZKA_PKN = 'orlen_paczka_pkn',
    GLS_PL_LOCKER = 'gls_pl_locker',
    GLS_PL_PARCELSHOP = 'gls_pl_parcelshop',
    HRVATSKA_POSTA_PUDO = 'hrvatska_posta_pudo',
    POST_LUXEMBOURG_PUDO = 'post_luxembourg_pudo',
    DHL_PUDO = 'dhl_pudo',
    FEDEX_PUDO = 'fedex_pudo',
    CTT_PUDO = 'ctt_pudo',
    ECONT_APS = 'econt_aps',
    ECONT_OFFICE = 'econt_office',
    PPL_PUDO = 'ppl_pudo',
    PPL_BOX = 'ppl_box',
    BALIKOVNA_PUDO = 'balikovna_pudo',
    BALIKOVNA_BOX = 'balikovna_box',
    DPD_POLAND_STANDARD_POINT = 'dpd_poland_standard_point',
    DPD_POLAND_STAFFED_POINT = 'dpd_poland_staffed_point',
    DPD_POLAND_NETWORK_POINT = 'dpd_poland_network_point',
    DPD_POLAND_POINTPACK_POINT = 'dpd_poland_pointpack_point',
    DPD_POLAND_ZABKA_POINT = 'dpd_poland_zabka_point',
    DPD_POLAND_SWIPBOX_INFINITY_POINT = 'dpd_poland_swipbox_infinity_point',
    DPD_POLAND_FOREIGN_LOCKER = 'dpd_poland_foreign_locker',
    DPD_POLAND_FOREIGN_EXTERNAL_POINT = 'dpd_poland_foreign_external_point',

    // Carriers offered through the Kvikk aggregator
    KVIKK_GLS = 'kvikk_gls',
    KVIKK_DPD = 'kvikk_dpd',
    KVIKK_PACKETA = 'kvikk_packeta',
    KVIKK_MPL = 'kvikk_mpl',
    KVIKK_GLS_HD = 'kvikk_gls_hd',
    KVIKK_DPD_HD = 'kvikk_dpd_hd',
    KVIKK_PACKETA_HD = 'kvikk_packeta_hd',
    KVIKK_MPL_HD = 'kvikk_mpl_hd',
    KVIKK_FOXPOST_HD = 'kvikk_foxpost_hd',
    KVIKK_ALZABOX = 'kvikk_alzabox',
    KVIKK_PARCEL_SHOP = 'kvikk_parcel_shop',
    KVIKK_LOCKER = 'kvikk_locker',
    KVIKK_SHOP = 'kvikk_shop',
    KVIKK_FOXPOST = 'kvikk_foxpost',
    KVIKK_ZBOX = 'kvikk_zbox',
    KVIKK_ZPONT = 'kvikk_zpont',
    KVIKK_AUTOMATA = 'kvikk_automata',
    KVIKK_POSTA = 'kvikk_posta',
    KVIKK_POSTA_PONT = 'kvikk_posta_pont',

    HOME_DELIVERY = 'home_delivery',
}
